import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useGoBack } from 'hooks/useGoBack';
import { IconButton } from 'shared/mui/IconButtons';
import { PageHeader } from 'shared/mui/PageHeader';
import { Stack } from 'shared/mui/Stack/Stack';
import { TypographyTitle } from 'shared/mui/Typography';
import { CreateProps } from 'shared/react-admin/Create/Create';

import { CreateStyled, BoxStyled } from './CreatePage.styled';

export type CreatePageProps = {
  title: string;
  listName: string;
  children: React.ReactNode;
} & CreateProps;

export const CreatePage: React.FC<CreatePageProps> = ({
  title,
  listName,
  children,
  redirect = 'list',
  ...props
}) => {
  const { goBack } = useGoBack();

  return (
    <BoxStyled>
      <PageHeader
        breadCrumbs={{
          currentPage: title,
          listName,
        }}
      />
      <CreateStyled actions={false} redirect={redirect} {...props}>
        <Stack alignItems="center" direction="row" gap={1}>
          <IconButton onClick={goBack}>
            <ArrowBackIcon />
          </IconButton>
          <TypographyTitle fontWeight={500} lineHeight={1} size="small">
            {title}
          </TypographyTitle>
        </Stack>
        {children}
      </CreateStyled>
    </BoxStyled>
  );
};
